// material-ui
import { useTheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';

// assets
import logoIconLarg from 'assets/images/logo/cityoptima_logo.svg';

// ==============================|| LOGO ICON IMAGE ||============================== //

export default function LogoIcon() {
  const theme = useTheme();
  const dimension = theme.palette.mode === ThemeMode.DARK ? 40 : 40;

  return <img src={logoIconLarg} alt="AssetFront" width={dimension} height={dimension} style={{ display: 'block' }} />;
}
